import { CompanyBillCreate, Create, View } from "../Components/index.js";

export default [
    { path: "/voucher/store/journal/company-bill-create", component: CompanyBillCreate, name: "voucher.store.received.company.bill" },
    { path: "/voucher/store/journal/create", component: Create, name: "voucher.store.journal.create" },
    { path: "/voucher/store/journal/:id/view", component: View, name: "voucher.store.journal.view" }
];
